module.exports = __webpack_public_path__ + "82a9b0d3ba7f7f587846097cd1349023.svg";